import SyntheseEntityCdcController from './syntheseentities.cdc.controller';

export default {
    bindings: {
        getSynthese: '<'
    },
    template: require('./syntheseentities.cdc.html'),
    controller: SyntheseEntityCdcController
};
